import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { STATI, prioLabel } from "@/lib/api";

const STATO_CLS = {
  da_fare: "bg-amber-50 text-amber-700 border-amber-200",
  in_corso: "bg-blue-50 text-blue-700 border-blue-200",
  completata: "bg-emerald-50 text-emerald-700 border-emerald-200",
};
const PRIO_CLS = {
  bassa: "bg-slate-100 text-slate-600 border-slate-200",
  media: "bg-amber-100 text-amber-800 border-amber-300",
  alta: "bg-red-50 text-[#C8102E] border-red-200",
};

export const PriorityBadge = ({ value }) => (
  <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-bold ${PRIO_CLS[value]}`} data-testid="priority-badge">
    <span className={`h-1.5 w-1.5 rounded-full ${value === "alta" ? "bg-[#E8173A]" : value === "media" ? "bg-amber-500" : "bg-slate-400"}`} />
    {prioLabel(value)}
  </span>
);

export const StatusSelect = ({ task, onChange }) => (
  <Select value={task.stato} onValueChange={(v) => onChange(task, v)}>
    <SelectTrigger
      className={`h-8 w-[136px] rounded-full border text-xs font-bold ${STATO_CLS[task.stato]}`}
      data-testid={`task-status-select-${task.id}`}
      onClick={(e) => e.stopPropagation()}
    >
      <SelectValue />
    </SelectTrigger>
    <SelectContent>
      {STATI.map((s) => (
        <SelectItem key={s.value} value={s.value} data-testid={`task-status-option-${s.value}`}>{s.label}</SelectItem>
      ))}
    </SelectContent>
  </Select>
);

export const ClientStatoBadge = ({ stato }) => (
  <span
    className={`inline-flex rounded-full border px-2.5 py-0.5 text-xs font-bold ${
      stato === "attivo" ? "bg-emerald-50 text-emerald-700 border-emerald-200" : "bg-slate-100 text-slate-500 border-slate-200"
    }`}
    data-testid="client-stato-badge"
  >
    {stato === "attivo" ? "Attivo" : "Archiviato"}
  </span>
);
